/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import useScript from './useScript'
import { Link } from "react-router-dom";
import Alert from 'react-bootstrap/Alert';
import BusinessLink from './BusinessLink'
import ContactForm from "../sections/common/ContactForm"

const Footer = ({
  footer,
  ThemeColor,
  socialMedia,
  websiteBackgroundColor,
  businessCode,
  isWebsiteWidget,
  websiteFooterColor,
  contactSection,
  jobsPageShow,
  faqsPageShow,
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [show, setShow] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  /* const sectionStyle = {
    color: `${ThemeColor} !important`,
  }; */

  const url = process.env.REACT_APP_WIDGET_URL

  const status = useScript(`${url}/widget.js`)

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (status === 'ready' && window.plentoWidget && isWebsiteWidget) {
      window.plentoWidget(url, businessCode)
      return () => {
        if (window.plentoWidgetDestroy) {
          window.plentoWidgetDestroy()
        }
      }
    }
  }, [status, businessCode, url, isWebsiteWidget])

  const OpenPopup = () => {
    setIsModalVisible(true);
  }

  const onCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <footer className={footer.style} style={{ backgroundColor: websiteFooterColor }}>
      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container-fluid">
          <div className="footer-justify-content">
            <div className="footer-widget">
              <ul className="social-media">
                <li>
                  {" "}
                  <a
                    href={socialMedia?.facebook || 'https://facebook.com'}
                    hidden={!socialMedia?.facebook}
                    title="Facebook"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {" "}
                    <i className="fab fa-facebook-f" />{" "}
                  </a>{" "}
                </li>
                <li>
                  {" "}
                  <a
                    href={socialMedia?.instagram || 'https://www.instagram.com'}
                    hidden={!socialMedia?.instagram}
                    title="Instagram"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {" "}
                    <i className="fab fa-instagram" />{" "}
                  </a>{" "}
                </li>
                <li>
                  {" "}
                  <a
                    href={socialMedia?.twitter || 'https://www.twitter.com'}
                    hidden={!socialMedia?.twitter}
                    title="Twitter"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {" "}
                    <i className="fab fa-twitter" />{" "}
                  </a>{" "}
                </li>
                <li>
                  {" "}
                  <a
                    href={socialMedia?.yelp || 'https://www.yelp.com'}
                    hidden={!socialMedia?.yelp}
                    title="Yelp"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {" "}
                    <i className="fab fa-yelp" />{" "}
                  </a>{" "}
                </li>
                <li>
                  {" "}
                  <a
                    href={socialMedia?.linkedin}
                    hidden={!socialMedia?.linkedin}
                    title="LinkedIn"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {" "}
                    <i className="fab fa-linkedin"></i>{" "}
                  </a>{" "}
                </li>
                <li>
                  {" "}
                  <a
                    href={socialMedia?.tiktok}
                    hidden={!socialMedia?.tiktok}
                    title="TikTok"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {" "}
                    <i className="fab fa-tiktok" />{" "}
                  </a>{" "}
                </li>
              </ul>
            </div>
            <div className="footer-link">
              <ul>
                {faqsPageShow &&
                  <li>
                    {" "}
                    <BusinessLink to="/faqs">FAQs</BusinessLink>{" "}
                  </li>
                }
                {jobsPageShow &&
                  <li>
                    {" "}
                    <BusinessLink to="/jobs">Jobs</BusinessLink>{" "}
                  </li>
                }
                {contactSection?.contact_form &&
                  <li>
                    {/*eslint no-script-url: "off"*/}
                    <a
                      href="javascript:void(0)"
                      onClick={OpenPopup}
                      rel="noreferrer"
                    >
                      Contact Us
                    </a>
                  </li>
                }
                <li>
                  {" "}
                  <BusinessLink to="/privacy">Privacy Policy</BusinessLink>{" "}
                </li>
                <li>
                  {" "}
                  <BusinessLink to="/terms">Terms &amp; Conditions</BusinessLink>{" "}
                </li>
              </ul>
            </div>
          </div>
          <div className="footer-copyright">
            {/* <p>
              {" "}
              Copyright © 2021 <a style={sectionStyle} href={process.env.REACT_APP_MAIN_URL} target="_blank" rel="noreferrer">Plento Inc</a> All Rights
              Reserved.{" "}
            </p> */}
            <p>{" "}</p>
            <p className="footer-text" style={{ color: ThemeColor }}>
              {" "}
              Powered by <a href="https://www.plento.io" rel="noreferrer" target="_blank">Plento</a>
            </p>
            <Link to="#" className="back-to-top" onClick={scrollToTop}>
              Back to top <i className="fas fa-chevron-up" />{" "}
            </Link>
          </div>
        </div>
      </div>
      <ContactForm
        visible={isModalVisible}
        onCancel={onCancel}
        business={businessCode}
        setShow={setShow}
        websiteBackgroundColor={websiteBackgroundColor}
      />
      <Alert show={show} key="success" variant="success">
        Email sent successfully
      </Alert>
    </footer>
  );
};

export default Footer;
